var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSupercoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8755 2V3.29167M14.8755 3.29167C17.616 3.29167 20.2444 4.38035 22.1822 6.31823C24.1201 8.25611 25.2088 10.8844 25.2088 13.625V17.3708C21.9796 16.5958 18.4921 16.2083 14.8755 16.2083C11.2588 16.2083 7.77129 16.5958 4.54213 17.3708V13.625C4.54213 10.8844 5.63081 8.25611 7.56869 6.31823C9.50656 4.38035 12.1349 3.29167 14.8755 3.29167Z",
    stroke: "#367FFF",
    strokeWidth: 2.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 16.3375V11.0417H18.7505V16.3375",
    stroke: "#367FFF",
    strokeWidth: 2.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34629 21.375C2.12123 21.7647 2.00187 22.2064 2.00002 22.6564C1.99818 23.1064 2.11392 23.5491 2.33578 23.9406C2.55764 24.3321 2.87792 24.6589 3.26491 24.8886C3.6519 25.1182 4.09217 25.2428 4.54212 25.25H5.05879L7.12546 24.7333C12.2238 23.5454 17.5271 23.5454 22.6255 24.7333L24.6921 25.25H25.2088C25.6587 25.2428 26.099 25.1182 26.486 24.8886C26.873 24.6589 27.1933 24.3321 27.4151 23.9406C27.637 23.5491 27.7527 23.1064 27.7509 22.6564C27.749 22.2064 27.6297 21.7647 27.4046 21.375L25.0796 17.2417C18.3449 15.8813 11.4061 15.8813 4.67129 17.2417L2.34629 21.375Z",
    stroke: "#367FFF",
    strokeWidth: 2.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupercoach);
export default __webpack_public_path__ + "static/media/icon-supercoach.34daa603c3cbf8ce92354ef0f5138d47.svg";
export { ForwardRef as ReactComponent };